module.exports = __webpack_public_path__ + "media/images/flags/64/Nigeria-aa9f964423fe839bfef535fca81dae13.png";